module.exports = __webpack_public_path__ + "static/media/image-4.f0afeb17.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FacebookBusiness/image-4.png
// module id = 433
// module chunks = 0